import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import ConfirmActionModal from '../../common/ConfirmActionModal';
import t from '../../common/t';
export default function confirmComposerExit() {
  const target = 'flarum/forum/states/ComposerState';
  const managed = fields => fields.ccotPhotos?.simple || fields.ccotPhotoWarning;
  // Core's synchronous guard is retained for native composers. Simple mode
  // defers close/load until the forum modal has resolved the user's choice.
  override(target, 'preventExit', function (original, ...args) {
    if (!managed(this.fields)) return original(...args);
    return !this.ccotExitApproved && !!(this.isVisible() && this.onExit?.callback());
  });
  for (const method of ['close', 'load']) override(target, method, function (original, ...args) {
    if (!managed(this.fields) || !this.preventExit()) return original(...args);
    if (this.ccotExitPrompt) return method === 'load' ? Promise.resolve() : undefined;
    const fields = this.fields;
    let finish;
    this.ccotExitPrompt = new Promise(resolve => {
      finish = resolve;
    });
    return (async () => {
      try {
        await app.modal.show(ConfirmActionModal, {
          message: t('lib.post_images_discard'),
          confirmLabel: t('lib.discard_changes'),
          run: () => finish(true),
          onremove: () => finish(false)
        });
        if (!(await this.ccotExitPrompt) || this.fields !== fields) return;
        this.ccotExitApproved = true;
        return await original(...args);
      } finally {
        this.ccotExitApproved = false;
        this.ccotExitPrompt = null;
      }
    })();
  });
}
flarum.reg.add('bushcraftcn-ccot', 'forum/postImages/confirmComposerExit', confirmComposerExit);